import { useRef } from "react";
import { Camera, ImagePlus, X } from "lucide-react";

export const PHOTO_MAX = 3;
const MB = 15;

/** Optional install photos for a review: camera shortcut + picker, up to 3 images, thumbnails with remove. */
export function ReviewPhotoPicker({ photos, setPhotos, prefix = "review" }) {
  const cam = useRef(null);
  const pick = useRef(null);
  const add = (list) => {
    const incoming = [...list].filter((f) => f.type.startsWith("image/") && f.size <= MB * 1024 * 1024);
    setPhotos((prev) => [...prev, ...incoming].slice(0, PHOTO_MAX));
  };
  const remove = (i) => setPhotos((prev) => prev.filter((_, idx) => idx !== i));
  const full = photos.length >= PHOTO_MAX;

  return (
    <div data-testid={`${prefix}-photos`}>
      <div className="dg-eyebrow mb-2 flex items-center gap-2"><ImagePlus className="w-3 h-3" /> Photo of the finished job (optional, up to {PHOTO_MAX})</div>
      <div className="grid grid-cols-2 sm:flex gap-2">
        <button type="button" disabled={full} onClick={() => cam.current?.click()} className="dg-btn-ghost rounded-full px-4 py-2.5 min-h-[44px] text-sm flex items-center justify-center gap-2 disabled:opacity-40" data-testid={`${prefix}-photo-camera-btn`}>
          <Camera className="w-4 h-4" /> Take a photo
        </button>
        <button type="button" disabled={full} onClick={() => pick.current?.click()} className="dg-btn-ghost rounded-full px-4 py-2.5 min-h-[44px] text-sm flex items-center justify-center gap-2 disabled:opacity-40" data-testid={`${prefix}-photo-pick-btn`}>
          <ImagePlus className="w-4 h-4" /> Upload photo
        </button>
      </div>
      <input ref={cam} type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => { add(e.target.files); e.target.value = ""; }} data-testid={`${prefix}-photo-camera-input`} />
      <input ref={pick} type="file" multiple accept="image/*" className="hidden" onChange={(e) => { add(e.target.files); e.target.value = ""; }} data-testid={`${prefix}-photo-input`} />
      {photos.length > 0 && (
        <ul className="mt-3 flex flex-wrap gap-2" data-testid={`${prefix}-photo-list`}>
          {photos.map((f, i) => (
            <li key={`${f.name}-${i}`} className="relative w-20 h-20 rounded-lg overflow-hidden border border-slate-700 bg-slate-900" data-testid={`${prefix}-photo-${i}`}>
              <img src={URL.createObjectURL(f)} alt="" className="w-full h-full object-cover" onLoad={(e) => URL.revokeObjectURL(e.target.src)} />
              <button type="button" onClick={() => remove(i)} className="absolute top-0.5 right-0.5 w-7 h-7 rounded-full bg-slate-950/80 text-white grid place-items-center" aria-label="Remove photo" data-testid={`${prefix}-photo-remove-${i}`}><X className="w-3.5 h-3.5" /></button>
            </li>
          ))}
        </ul>
      )}
      {photos.length > 0 && <div className="text-xs text-slate-400 mt-1 font-mono" data-testid={`${prefix}-photo-count`}>{photos.length} photo{photos.length === 1 ? "" : "s"}{full ? " (max)" : ""}</div>}
    </div>
  );
}
